// extracted by mini-css-extract-plugin
export var container = "solutionDesktop-module--container--14qAq";
export var inner = "solutionDesktop-module--inner--1B-nI";
export var subtitle = "solutionDesktop-module--subtitle--20nmP";
export var title = "solutionDesktop-module--title--1TBAR";
export var accordernControlsWrap = "solutionDesktop-module--accordernControlsWrap--3f_sM";
export var jsAnimInit = "solutionDesktop-module--jsAnimInit--26joj";